import axios from 'axios';
import Cookies from 'js-cookie';
import { MDBCountdown, MDBCountdownUnit } from 'mdb-react-countdown';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBInput
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useContext, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { MiscContext } from '../context/MiscProvider';

const ForgotUserId = ({ isForgotPassword, setIsForgotPassword, setIsForgotUserId, isForgotUserId, setShowAlert, alertMessage, setAlertMessage, showAlert, setCountDown,countDown }) => {

    const [alertColor, setAlertColor] = useState('');
    const navigate = useNavigate();
    const { setForgotPasswordModalOpen, setForgotUserIdModalOpen } = useContext(MiscContext);
    const authUrl = process.env.REACT_APP_AUTH_URL;
    const registerFirstNameInput1 = useRef();
    const registerOtpInput1 = useRef();
    const registerUserIdInput1 = useRef();
    const registerLastNameInput1 = useRef();
    const registerCompanyNameInput1 = useRef();
    const registerEmailInput1 = useRef();

    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [showOtp, setShowOtp] = useState(false);
    const [otp, setOtp] = useState(null);
    const [userId, setUserId] = useState(null);
    const generateUniqueId = (baseId) => `${baseId}-${Math.random().toString(36).slice(2, 9)}`;
    const registerCompanyNameId = generateUniqueId('registerCompanyName1');
    const loginNameId = generateUniqueId('loginName_signIn');
    const registerEmailId = generateUniqueId('registerEmail');
    const registerLastNameId = generateUniqueId('registerLastName');
 
    const handleApply = async () => {
         // Fetch TOTP cookie before making the request
         const totpCookie = Cookies.get('TOTP');
    
         // Include the TOTP cookie in the request headers
         const headers = {
             'Content-Type': 'application/json'        };
     
         // If TOTP cookie exists, include it in the headers
         if (totpCookie) {
             headers['Cookie'] = `TOTP=${totpCookie}`;
         }
        const url = userId
            ? `${authUrl}/users/userIdAcknowledged/userId/${userId}/firsName/${firstName}/lastName/${lastName}/company/${companyName}`
            : otp ? `${authUrl}/otp/verify/${otp}` : `${authUrl}/users/userIdAcknowledged/email/${email}/firsName/${firstName}/lastName/${lastName}/company/${companyName}`;

        axios.get(url)
            .then(async response => {
                if (response.data) {
                    setAlertMessage(response.data.userMessage);
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 15000);
                    setFirstName('');
                    setLastName('');
                    setEmail('');
                    setCompanyName('');
                    setUserId('');
                    if (otp) {
                        setAlertMessage(response.data.message);
                        setCountDown(response.data.expiredInMinutes);
                        setShowAlert(true);
                        setShowOtp(false);
                        setForgotUserIdModalOpen(false);
                        setIsForgotPassword(false);
                        setForgotPasswordModalOpen(true);
                    }
                    else if (isForgotPassword) {
                        setShowOtp(true)
                        setIsForgotPassword(true);
                        setForgotUserIdModalOpen(false);
                        setCountDown(response.data.expiredInMinutes);
                    }
                    setOtp('');
                    if (isForgotUserId) {
                        setForgotUserIdModalOpen(false);
                        setAlertMessage(response.data.userMessage);
                        setIsForgotPassword(false);
                        setShowAlert(true);
                        setForgotPasswordModalOpen(false);
                        setShowOtp(false);
                    }

                }
            })
            .catch(error => {

                setAlertMessage(showOtp ? 'ERROR: Invalid OTP' : `ERROR: Incorrect input `);
                setAlertColor('danger');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 15000);
            });
    };
    const now = new Date();
    const endTime = new Date(now.getTime() + countDown * 60000);


    return (
        <section className="grainy-gradient-intro " style={{ marginBottom: '20px' }}>

            <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '5px' }}> { showOtp ? 'Verify OTP' : isForgotPassword ? 'Temp password' : 'Retrieve UserId'} </h5>
            <hr className="hr" />
            <MDBCard>

                {showOtp ? (<MDBCardBody>
                    
                    <MDBCountdown countdown={endTime} position='horizontal' >
                    <div className="d-flex  justify-content-center align-items-center gap-2 mb-2" >
  <MDBCountdownUnit label=' mins' className='text-primary fw-bold' type='minutes' />
  <MDBCountdownUnit label=' secs' className='text-black' type='seconds' />
  </div>
</MDBCountdown>
                    <MDBInput
                        ref={registerOtpInput1}
                        className="mb-4"
                        type="text"
                        id="registerOtpFuid1"
                        label="OTP*"
                        value={otp}
                        onChange={e => setOtp(e.target.value)}
                    />
                    <div className="d-grid gap-2 d-md-block">
                        <MDBBtn
                            disabled={!otp}

                            onClick={handleApply}

                        >submit
                        </MDBBtn>


                        <MDBBtn className='mx-2' color='danger' onClick={() => { setIsForgotUserId(false); setIsForgotPassword(false); setShowOtp(false); setOtp('') }}>
                            close
                        </MDBBtn>


                    </div>
                </MDBCardBody>) :

                    <div> <MDBCardBody className="text-center">

                        {isForgotPassword && <MDBInput
                            ref={registerUserIdInput1}
                            className="mb-4"
                            type="text"
                            id={loginNameId}
                            label="UserId*"
                            value={userId}
                            onChange={e => setUserId(e.target.value)}
                        />}

                        {!showOtp && <MDBInput
                            ref={registerFirstNameInput1}
                            className="mb-4"
                            type="text"
                            id={registerFirstNameInput1}
                            label="First Name*"
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />}

                        {!showOtp && <MDBInput

                            ref={registerLastNameInput1}
                            className="mb-4"
                            type="text"
                            id={registerLastNameId}
                            label="LastName*"
                            value={lastName}
                            onChange={e => { setLastName(e.target.value); setCompanyName(e.target.value) }}

                        />}

                        {!showOtp &&
                            <MDBInput
                                ref={registerCompanyNameInput1}
                                className="mb-4"
                                type="text"
                                id={registerCompanyNameId}
                                label="CompanyName*"
                                value={companyName}
                                onChange={e => setCompanyName(e.target.value)}

                            />}

                        {!showOtp && isForgotUserId && <MDBInput
                            ref={registerEmailInput1}
                            className="mb-4"
                            type="email"
                            id={registerEmailId}
                            label="Email*"
                            value={email}
                            onChange={e => setEmail(e.target.value)}

                        />}
                        <div className="d-grid gap-2 d-md-block">
                            <MDBBtn disabled={!firstName || !lastName || (isForgotUserId && !email) || !companyName || (isForgotPassword && !userId)} onClick={() => { handleApply() }}>submit</MDBBtn>
                            {/* <MDBPopconfirm
                                    disabled={!firstName || !lastName || !email || !companyName}
                                    modal
                                    btnChildren="Submit"
                                    onConfirm={handleApply}
                                    onCancel={() => { }}
                                    cancelBtnText='Cancel'
                                    //cancelBtnClasses={showAlert ? 'd-none' : ''}
                                    cancelBtnClasses={`btn-warning  'd-none'`}
                                    confirmBtnClasses={`btn-primary `}
                                > 
                                    
                                    <MDBPopconfirmMessage><p>{`First Name: ${firstName}`}</p><p>{`First Name: ${firstName}`}</p> <p>{`Last Name: ${lastName}`}</p><p>{`Email: ${email}`}</p> <p>{`Company Name: ${companyName}`}</p></MDBPopconfirmMessage>
                                </MDBPopconfirm>*/}

                            <MDBBtn className='mx-2' color='danger' onClick={() => { !showOtp && setIsForgotUserId(false); !showOtp && setIsForgotPassword(false) }}>close</MDBBtn>
                        </div>
                    </MDBCardBody>    </div>}
            </MDBCard>

        </section>
    );
};
ForgotUserId.propTypes = {
    isForgotPassword: PropTypes.bool,
    setIsForgotUserId: PropTypes.func,
    setIsForgotPassword: PropTypes.func,
    isForgotUserId: PropTypes.bool,
    setShowAlert: PropTypes.func,
    setAlertMessage: PropTypes.func,
    setCountDown: PropTypes.func,
    alertMessage: PropTypes.string,
    showAlert: PropTypes.func,
    countDown: PropTypes.number,
}

export default ForgotUserId;
